module.exports = __webpack_public_path__ + "668e87b8c2aed72302ae43746bc36379.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-4.png
// module id = 3330
// module chunks = 0